import React from 'react'
import './Loading.css'

const Loading = () => {
  return (
    <div className='loader' ></div>
  )
}

export default Loading